<template>
    <section class="tables new-updated-design px-0 px-md-0 pt-4 pt-md-0">
        <vue-snotify></vue-snotify>
        <div>
            <b-modal id="invoice-modal" ref="invoice-modal" scrollable :title="$t('property_detail.Booking_detail')"
                size="xl" :hide-footer="true" @hidden="clearInvoice">
                <div class="invoice-table" v-if="selectedInvoice">
                    <div class="top-content d-flex align-items-center justify-content-between gap-2">
                        <div class="header-logo">
                            <img src="../public/assets/images/cheapcomfort-logo.svg" alt="logo">
                        </div>
                    </div>
                    <div class="body-content">
                        <div class="body-head">
                            <h3 class="title">{{ $t('Propertis.Customer_Information') }}</h3>
                            <div class="row">
                                <div class="col-lg-4 col-md-6">
                                    <div class="form-group">
                                        <label for="">{{ $t('register.name') }}:</label> <span>{{
                                            selectedInvoice.first_name }}</span>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6">
                                    <div class="form-group">
                                        <label for="">{{ $t('login.email') }}:</label> <span>{{ selectedInvoice.email
                                            }}</span>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6">
                                    <div class="form-group">
                                        <label for="">{{ $t('register.phone') }}:</label> <span>{{
                                            selectedInvoice.phone_number }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="body-table-content">
                            <div class="responsive-table">
                                <h3 class="title">{{ $t('Propertis.Reservation_Details') }}</h3>
                                <table>
                                    <thead>
                                        <tr>
                                            <th>{{ $t('Propertis.Title') }}</th>
                                            <th>{{ $t('Propertis.Description') }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{{ $t('Propertis.Accommodation_Name') }}:</td>
                                            <td>{{ selectedInvoice.property?.property_type || 'N/A' }}</td>
                                        </tr>
                                        <tr>
                                            <td>{{ $t('Propertis.Property_Address') }}:</td>
                                            <td>{{ selectedInvoice.property.address }}</td>
                                        </tr>
                                        <tr>
                                            <td>{{ $t('Propertis.Length_of_Stay') }}:</td>
                                            <td>{{ selectedInvoice.number_of_nights }} {{ $t('Propertis.nights') }}</td>
                                        </tr>
                                        <tr>
                                            <td>{{ $t('Propertis.Accommodation_Type_Reserved') }}:</td>
                                            <td>{{ selectedInvoice.property.accommodation_type }}</td>
                                        </tr>
                                        <tr>
                                            <td>{{ $t('Propertis.number_of_guests') }}:</td>
                                            <td>{{ selectedInvoice.number_of_guests }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="responsive-table financial-table">
                                <h3 class="title">{{ $t('Propertis.Financial_Details') }}</h3>
                                <table>
                                    <thead>
                                        <tr>
                                            <th>{{ $t('Propertis.Title') }}</th>
                                            <th>{{ $t('Propertis.Description') }}</th>
                                            <th>{{ $t('booking.Amount') }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{{ $t('booking.total_price') }}:</td>
                                            <td>{{ $t('Propertis.Total_Reservation_Description') }}
                                            </td>
                                            <td>{{ selectedInvoice.payment_currency }} {{ selectedInvoice.total_price }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>{{ $t('Propertis.Currency') }}:</td>
                                            <td>{{ selectedInvoice.payment_currency }}</td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td>{{ $t('payment.payment_method') }}:</td>
                                            <td>{{ $t('Propertis.Payment_Policy_Description') }}</td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td>{{ $t('Propertis.Cancellation') }}:</td>
                                            <td>{{ $t('Propertis.Cancellation_Description') }}</td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td>{{ $t('payment.discounted_amount') }}:</td>
                                            <td></td>
                                            <td>{{ selectedInvoice.payment_currency }} {{
                                                selectedInvoice.discount_amount }}</td>
                                        </tr>
                                        <tr>
                                            <td>{{ $t('discounts.discount_percentage') }}:</td>
                                            <td></td>
                                            <td>{{ selectedInvoice.discount_percentage }}%</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="responsive-table">
                                <h3 class="title">{{ $t('Propertis.Other_Details') }}</h3>
                                <table>
                                    <thead>
                                        <tr>
                                            <th>{{ $t('Propertis.Title') }}</th>
                                            <th>{{ $t('Propertis.Description') }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{{ $t('property_detail.Property_Policies') }}:</td>
                                            <td v-html="selectedInvoicePolicies"></td>
                                        </tr>
                                        <tr>
                                            <td>{{ $t('Propertis.Included_Services') }}:</td>
                                            <td>{{ selectedInvoiceServices }}</td>
                                        </tr>
                                        <tr>
                                            <td>{{ $t('Propertis.Property_Contact_Information') }}:</td>
                                            <td>{{ selectedInvoice.property.user.email }} <b>{{ $t('common.and') }}</b>
                                                {{
                                                    selectedInvoice.property.user.mobile_phone }} {{
                                                $t('common.for_inquiries') }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="price-list">
                            <h3 class="amount">{{ $t('booking.total_price') }}: <span class="price">{{
                                    selectedInvoice.payment_currency }}
                                    {{ selectedInvoice.total_price }}</span></h3>
                        </div>
                    </div>
                    <div class="footer-content">
                        <p class="text-center"> <span>support@cheapcomforts.com</span><span>cheapcomforts.com</span></p>
                    </div>
                </div>
            </b-modal>
        </div>
        <div>
            <b-modal id="check-modal" ref="checkModal" hide-footer
                :title="checkActionType === 'checkIn' ? $t('dashboard.check_in_time') : $t('dashboard.check_out_time')">
                <b-form @submit.prevent="submitCheckAction">
                    <div class="form-group">
                        <label class="selectdate-time" for="checkDateTime">{{ $t('dashboard.select_date_time')
                            }}</label>
                        <date-picker v-model="date" type="datetime" value-type="format" placeholder="Select Date & Time"
                            :show-time-panel.sync="showDatePickerTimePanel" @pick="onPickDate" @open="onPickerOpen"
                            :open.sync="openDatePicker" :title-format="userFormat" format="DD-MM-YYYY HH:mm"
                            :show-second="false" :minute-step="1" input-class="form-control" @change="onDateChange">
                            <i slot="icon-calendar">
                                <i class="far fa-calendar-alt"></i>
                            </i>
                            <template v-slot:footer>
                                <button v-if="showDatePickerTimePanel" class="mx-btn mx-btn-text pull-left"
                                    @click="showDatePickerTimePanel = false">
                                    {{ $t('dashboard.select_date') }}
                                </button>
                                <button v-else class="mx-btn mx-btn-text pull-left"
                                    @click="showDatePickerTimePanel = true">
                                    {{ $t('dashboard.select_time') }}
                                </button>
                                <button class="mx-btn mx-btn-text" @click="openDatePicker = false">
                                    {{ $t('sweetalert.OK') }}
                                </button>
                            </template>
                        </date-picker>

                    </div>
                    <div class="d-flex justify-content-end check-in-time">
                        <b-button class="btn btn-danger mr-2" @click="$refs.checkModal.hide()">{{
                            $t('sweetalert.cancel') }}</b-button>
                        <!-- <b-button variant="primary" type="submit" class="ml-2">Submit</b-button> -->
                        <b-button variant="primary" type="submit" class="ml-2" :disabled="isButtonDisabled">{{
                            buttonText || $t('common.submit')
                            }}</b-button>
                    </div>
                </b-form>
            </b-modal>
        </div>
        <div>
            <b-card no-body>
                <b-tabs card @input="onTabChange">
                    <b-tab :title="$t('dashboard.bookings')" active></b-tab>
                    <b-tab :title="$t('dashboard.check_in_guests')"></b-tab>
                    <b-tab :title="$t('dashboard.check_out_guests')"></b-tab>
                </b-tabs>

                <div class="row mt-3">
                    <div class="col-lg-12 grid-margin stretch-card properties-table">
                        <div class="container mw-100">
                            <div class="card">
                                <div class="card-header">
                                    <h4 class="card-title">{{ currentTabTitle }}</h4>
                                </div>
                                <div class="card-body">
                                    <div class="search-bar mb-3 search-bar-style">
                                        <b>{{ $t('common.search') }}: </b>
                                        <input style="border: 1px solid #dcdfe6;" type="text"
                                            :placeholder="$t('common.search_placeholder')" v-model="serverParams.search"
                                            @input="onSearch" />
                                    </div>
                                    <vue-good-table mode="remote" :rows="rows" :columns="columns"
                                        :totalRows="totalRecords" :pagination-options="paginationOptions"
                                        :sort-options="{ enabled: false }" @on-page-change="onPageChange"
                                        @on-per-page-change="onPerPageChange">
                                        <template slot="table-row" slot-scope="props">
                                            <!-- Bookings Tab -->
                                            <template v-if="activeTab === 0">
                                                <span v-if="props.column.field === 'name'">{{ props.row.user.name
                                                    }}</span>
                                                <span v-else-if="props.column.field === 'email'">{{ props.row.user.email
                                                    }}</span>
                                                <span v-else-if="props.column.field === 'mobile_phone'">{{
                                                    props.row.user.mobile_phone }}</span>
                                                <span v-else-if="props.column.field === 'total_price'">{{
                                                    props.row.payment_currency }} {{ props.row.total_price
                                                    }}</span>
                                                <span v-else-if="props.column.field === 'commission'">{{
                                                    props.row.payment_currency }} {{ props.row.commission
                                                    }}</span>
                                                <span v-else-if="props.column.field === 'property_type'">
                                                    {{ $t('property_detail.' + props.row.property.property_type) }}
                                                </span>
                                                <span v-else-if="props.column.field === 'action'"
                                                    class="text-nowrap properties-btns">
                                                    <b-button @click="viewInvoiceDetails(props.row)"
                                                        class="mr-1 edit-btn">
                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"
                                                            width="17" height="17" fill="white">
                                                            <path
                                                                d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z" />
                                                        </svg>
                                                    </b-button>
                                                    <b-button @click="cancelBooking(props.row.id, props.row)"
                                                        class="mr-1 cancel-btn">
                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512"
                                                            width="17" height="17" fill="white">
                                                            <path
                                                                d="M242.7 256L345.4 153.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L197.3 210.7 94.6 108c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L152.7 256 49.4 359.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L197.3 301.3 300 404c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L242.7 256z" />
                                                        </svg>
                                                    </b-button>

                                                </span>
                                            </template>

                                            <!-- Check-in Guests Tab -->
                                            <template v-else-if="activeTab === 1">
                                                <span v-if="props.column.field === 'name'">{{ props.row.user.name
                                                    }}</span>
                                                <span v-else-if="props.column.field === 'start_date'">{{
                                                    formatDate(props.row.start_date) }}</span>
                                                <span v-else-if="props.column.field === 'email'">{{ props.row.user.email
                                                    }}</span>
                                                <span v-else-if="props.column.field === 'property_type'">
                                                    {{ $t('property_detail.' + props.row.property.property_type) }}
                                                </span>
                                                <span v-else-if="props.column.field === 'action'">
                                                    <!-- <b-button variant="success" size="sm"
                                                        @click="handleCheckIn(props.row)">Check-in</b-button> -->
                                                    <b-button
                                                        v-if="!props.row.guest_check_in_out || !props.row.guest_check_in_out.is_checked_in"
                                                        variant="success" size="sm" @click="handleCheckIn(props.row)">{{
                                                        $t('Propertis.Check_in') }}</b-button>

                                                    <span v-else class="text-success font-weight-bold"> {{
                                                        $t('dashboard.checked_in') }}</span>
                                                </span>
                                            </template>

                                            <!-- Check-out Guests Tab -->
                                            <template v-else-if="activeTab === 2">
                                                <span v-if="props.column.field === 'name'">{{ props.row.user.name
                                                    }}</span>
                                                <span v-else-if="props.column.field === 'end_date'">{{
                                                    formatDate(props.row.end_date) }}</span>
                                                <span v-else-if="props.column.field === 'email'">{{ props.row.user.email
                                                    }}</span>
                                                <span v-else-if="props.column.field === 'property_type'">
                                                    {{ $t('property_detail.' + props.row.property.property_type) }}
                                                </span>
                                                <span v-else-if="props.column.field === 'action'">
                                                    <!-- <b-button variant="danger" size="sm"
                                                        @click="handleCheckOut(props.row)">Check-out</b-button> -->
                                                    <b-button v-if="props.row.guest_check_in_out &&
                                                        props.row.guest_check_in_out.is_checked_in &&
                                                        !props.row.guest_check_in_out.is_checked_out" variant="danger"
                                                        size="sm" @click="handleCheckOut(props.row)">{{
                                                        $t('Propertis.Check_out') }}</b-button>

                                                    <span v-else-if="props.row.guest_check_in_out?.is_checked_out"
                                                        class="badge bg-primary font-weight-bold"> {{
                                                        $t('dashboard.checked_out') }}</span>
                                                    <span v-else class="badge bg-danger text-white">{{
                                                        $t('dashboard.not_checked_in') }}</span>
                                                </span>

                                            </template>
                                            <div v-if="noDataFound && !isLoading" class="text-center text-muted">
                                                {{ $t('common.no_data_available') }}
                                            </div>
                                        </template>
                                    </vue-good-table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </b-card>
        </div>
    </section>
</template>
<script>
import API from '@/api'
import moment from 'moment'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
export default {
    name: 'BookingsTabs',
    components: {
        DatePicker
    },
    data() {
        const now = new Date();
        return {
            activeTab: 0,
            time1: '', // Holds the selected date-time
            showDatePickerTimePanel: false,
            openDatePicker: false,
            userFormat: 'YYYY-MM-DD HH:mm',
            rows: [],
            totalRecords: 0,
            noDataFound: false,
            serverParams: {
                search: "",
                sort: [
                    {
                        field: 'id',
                        type: 'desc'
                    }
                ],
                page: 1,
                perPage: 10
            },
            paginationOptions: {
                enabled: true,
                dropdownAllowAll: false,
                perPageDropdown: [10, 20, 50, 100, 200],
                nextLabel: this.$t('pagination.next'),
                prevLabel: this.$t('pagination.Previous'),
                rowsPerPageLabel: this.$t('pagination.rowsPerPage'),
                ofLabel: this.$t('pagination.of'),
            },
            isLoading: false,
            selectedInvoice: null,
            checkActionType: null,
            checkSelectedRow: null,
            checkDateTime: this.formatDateTime(now),
            minDateTime: this.formatDateTime(now),
            isButtonDisabled: false,
            buttonText: this.$t('common.submit'),
        };
    },
    computed: {
        currentTabTitle() {
            switch (this.activeTab) {
                case 0: return this.$t('properties_list.View_Bookings');
                case 1: return this.$t('dashboard.check_in_guests');
                case 2: return this.$t('dashboard.check_out_guests');
                default: return '';
            }
        },
        columns() {
            switch (this.activeTab) {
                case 0: // Bookings
                    return [
                        { label: this.$t('booking.Guest'), field: 'name' },
                        { label: this.$t('booking.Guest_Email'), field: 'email' },
                        { label: this.$t('booking.Guest_Contact'), field: 'mobile_phone' },
                        { label: this.$t('booking.total_price'), field: 'total_price' },
                        { label: this.$t('payment.commission'), field: 'commission' },
                        { label: this.$t('properties_list.Property_Type'), field: 'property_type' },
                        { label: this.$t('properties_list.action'), field: 'action' },
                    ];
                case 1: // Check-in Guests
                    return [
                        { label: this.$t('booking.Guest'), field: 'name' },
                        { label: this.$t('dashboard.check_in_date'), field: 'start_date' },
                        { label: this.$t('properties_list.Property_Type'), field: 'property_type' },
                        { label: this.$t('booking.Guest_Email'), field: 'email' },
                        { label: this.$t('properties_list.action'), field: 'action' }
                    ];
                case 2: // Check-out Guests
                    return [
                        { label: this.$t('booking.Guest'), field: 'name' },
                        { label: this.$t('dashboard.check_out_date'), field: 'end_date' },
                        { label: this.$t('properties_list.Property_Type'), field: 'property_type' },
                        { label: this.$t('booking.Guest_Email'), field: 'email' },
                        { label: this.$t('properties_list.action'), field: 'action' }
                    ];
                default: return [];
            }
        },
        selectedInvoiceServices() {
            const services = [];
            const property = this.selectedInvoice.property;
            if (property.wifi_available == 1) services.push(this.$t('Propertis.Wifi'));
            if (property.tv_available == 1) services.push(this.$t('Propertis.TV'));
            if (property.kitchen_available == 1) services.push(this.$t('Propertis.Kitchen'));

            return services.length ? services.join(', ') : this.$t('common.none');
        },
        selectedInvoicePolicies() {
            const policies = [];

            // Children Policy
            const childrenValue = this.selectedInvoice.property.children
                ? this.selectedInvoice.property.children.toLowerCase()
                : this.$t('property_detail.no');
            policies.push(this.$t('Propertis.children_are', { children: childrenValue }));

            // Events Policy
            const eventsValue = this.selectedInvoice.property.Events
                ? this.selectedInvoice.property.Events.toLowerCase()
                : this.$t('property_detail.no');
            policies.push(this.$t('Propertis.events_are', { events: eventsValue }));

            // Pets Policy
            const petsValue = this.selectedInvoice.property.Pets
                ? this.selectedInvoice.property.Pets.toLowerCase()
                : this.$t('property_detail.no');
            policies.push(this.$t('Propertis.pets_are', { pets: petsValue }));

            // Smoking Policy
            const smokingValue = this.selectedInvoice.property.Smoking
                ? this.selectedInvoice.property.Smoking.toLowerCase()
                : this.$t('property_detail.no');
            policies.push(this.$t('Propertis.Smoking_is', { smoking: smokingValue }));

            return policies.length ? policies.join('<br>') : this.$t('common.no_policies');
        }
    },
    methods: {
        onSearch() {
            this.serverParams.page = 1;
            this.loadData();
        },
        onPickerOpen() {
            this.showDatePickerTimePanel = false
        },
        onPickDate(date) {
            this.showDatePickerTimePanel = true
        },
        onDateChange(value, type, obj) {
            console.log('Selected value:', value)
        },
        onTabChange(index) {
            this.activeTab = index;
            this.rows = [];
            this.serverParams.page = 1;
            this.selectedInvoice = null;
            this.loadData();
        },
        clearInvoice() {
            this.selectedInvoice = null;
        },
        formatDateTime(date) {
            const pad = (n) => n.toString().padStart(2, '0');
            return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
        },
        loadData() {
            this.isLoading = true;

            switch (this.activeTab) {
                case 0: // Bookings
                    API.getPropertyOwnerBookings(this.serverParams,
                        data => {
                            this.handleDataResponse(data);
                        },
                        err => {
                            this.handleDataError(err);
                        }
                    );
                    break;

                case 1: // Check-in Guests
                    API.getCheckInGuests(this.serverParams,
                        data => {
                            this.handleDataResponse(data);
                        },
                        err => {
                            this.handleDataError(err);
                        }
                    );
                    break;

                case 2: // Check-out Guests
                    API.getCheckOutGuests(this.serverParams,
                        data => {
                            this.handleDataResponse(data);
                        },
                        err => {
                            this.handleDataError(err);
                        }
                    );
                    break;
            }
        },
        handleDataResponse(data) {
            this.totalRecords = data.totalRecords ?? 0;

            this.rows = (data.data ?? []).map(booking => {
                const startMoment = moment(booking.start_date, 'YYYY-MM-DD');
                const today = moment();
                const checkInOut = booking.guest_check_in_out || {};
                const isCheckedIn = checkInOut.is_checked_in === 1;
                const checkInTime = checkInOut.check_in_date_time ? moment(checkInOut.check_in_date_time) : null;

                let cancellationInfo = {
                    status: 'active',
                    message: ''
                };

                if (isCheckedIn) {
                    cancellationInfo.status = 'expired';
                    cancellationInfo.message = this.$t('booking.guest_checked_in_message');
                } else if (today.diff(startMoment, 'days') > -7) {
                    cancellationInfo.status = 'expired';
                    cancellationInfo.message = this.$t('booking.cancel_7_days');
                } else if (checkInTime && today.isAfter(checkInTime.clone().add(24, 'hours'))) {
                    cancellationInfo.status = 'expired';
                    cancellationInfo.message = this.$t('booking.payout_window_passed');
                } else {
                    cancellationInfo.message = this.$t('booking.can_cancel_booking');
                }

                return {
                    ...booking,
                    cancellationInfo
                };
            });

            this.noDataFound = this.rows.length === 0;
            this.isLoading = false;
        },
        // handleDataResponse(data) {
        //     this.totalRecords = data.totalRecords ?? 0;
        //     this.rows = data.data ?? [];

        //     this.noDataFound = this.rows.length === 0;
        //     this.isLoading = false;
        // },
        handleDataError(err) {
            console.error(err);
            this.isLoading = false;
            this.$showNotification({
                message: this.$t('error_messages.failed_load_data')
            }, "error");
        },
        onPageChange(params) {
            this.serverParams.page = params.currentPage;
            this.loadData();
        },
        onPerPageChange(params) {
            this.serverParams.perPage = params.currentPerPage;
            this.serverParams.page = 1;
            this.loadData();
        },
        formatDate(date) {
            return moment(date).format('DD-MM-YYYY');
        },
        viewInvoiceDetails(booking) {
            this.selectedInvoice = booking;
            this.$refs['invoice-modal'].show();
        },
        formatTime(time) {
            if (!time) return this.$t('common.na');
            const [hours, minutes] = time.split(':');
            const hoursInt = parseInt(hours);
            const period = hoursInt >= 12 ? 'PM' : 'AM';
            const formattedHours = hoursInt % 12 || 12;
            return `${formattedHours}:${minutes} ${period}`;
        },
        handleCheckIn(row) {
            this.checkActionType = 'checkIn';
            this.checkSelectedRow = row;
            const now = moment().format('DD-MM-YYYY HH:mm');
            this.checkDateTime = now;
            this.date = now; // sync with date-picker
            this.$refs.checkModal.show();
        },
        handleCheckOut(row) {
            this.checkActionType = 'checkOut';
            this.checkSelectedRow = row;
            const now = moment().format('DD-MM-YYYY HH:mm');
            this.checkDateTime = now;
            this.date = now; // sync with date-picker
            this.$refs.checkModal.show();
        },
        submitCheckAction() {
            // const formattedDateTime = moment(this.checkDateTime).format('YYYY-MM-DD HH:mm:ss');
            const formattedDateTime = moment(this.checkDateTime, 'DD-MM-YYYY HH:mm').format('YYYY-MM-DD HH:mm:ss');
            // Set the loading state and disable the button
            this.isLoading = true;
            this.isButtonDisabled = true;
            this.buttonText = this.$t('common.submitting');

            const apiCall = this.checkActionType === 'checkIn' ? API.checkInGuest : API.checkOutGuest;
            const successTitle = this.checkActionType === 'checkIn'
                ? this.$t('dashboard.checked_in')
                : this.$t('dashboard.checked_out');
            // const successMessage = this.checkActionType === 'checkIn'
            //     ? `Guest successfully checked in at ${formattedDateTime}`
            //     : `Guest successfully checked out at ${formattedDateTime}`;
            const successMessage = this.$t(this.checkActionType === 'checkIn' ? 'booking.guest_checked_in' : 'booking.guest_checked_out', { time: formattedDateTime });

            // Call the API
            apiCall(
                {
                    payment_id: this.checkSelectedRow.id,
                    date_time: formattedDateTime
                },
                () => {
                    // Handle success
                    this.$refs.checkModal.hide();
                    this.loadData();

                    // Reset loading state
                    this.isLoading = false;
                    this.isButtonDisabled = false;
                    this.buttonText = successTitle;

                    // Display success notification
                    this.$swal({
                        title: successTitle,
                        text: successMessage,
                        icon: 'success',
                        type: 'success',
                        confirmButtonText: this.$t('common.ok')
                    });
                },
                () => {
                    // Handle error
                    this.isLoading = false;
                    this.isButtonDisabled = false;
                    this.buttonText = this.$t('common.retry');

                    // Display error notification
                    this.$swal({
                        title: this.$t('common.error'),
                        text: this.$t('booking.action_failed'),
                        icon: 'error',
                        type: 'error',
                        confirmButtonText: this.$t('common.ok')
                    });
                }
            );
        },
       
        async cancelBooking(bookingId, booking) {
            const startMoment = moment(booking.start_date, 'YYYY-MM-DD');
            const today = moment();
            const checkInOut = booking.guest_check_in_out || {};
            const isCheckedIn = checkInOut.is_checked_in === 1;
            const checkInTime = checkInOut.check_in_date_time ? moment(checkInOut.check_in_date_time) : null;

            let cancellationAllowed = false;
            let errorMessage = '';

            // Rule 1: Cannot cancel after guest checked in
            if (isCheckedIn) {
                errorMessage = this.$t('booking.cannot_cancel_checked_in');
            }
            // Rule 2: Must notify 7 days prior
            else if (today.diff(startMoment, 'days') > -7) {
                errorMessage = this.$t('booking.cancel_7_days');
            }
            // Rule 3: Cannot cancel after payout window (24h after check-in)
            else if (checkInTime && today.isAfter(checkInTime.clone().add(24, 'hours'))) {
                errorMessage = this.$t('booking.cannot_cancel_payout');
            }
            else {
                cancellationAllowed = true;
            }

            if (!cancellationAllowed) {
                this.$swal({
                    title: this.$t('booking.cancellation_not_allowed'),
                    text: errorMessage,
                    icon: 'error',
                    type: 'error',
                    confirmButtonText: this.$t('common.ok')
                });
                return;
            }

            try {
                const confirmation = await this.$swal({
                    title: this.$t('booking.confirm_host_cancellation'),
                    text: this.$t('booking.confirm_cancel_text'),
                    icon: 'warning',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: this.$t('booking.yes_cancel_booking'),
                    cancelButtonText: this.$t('booking.no_keep_booking')
                });

                if (!confirmation.value) return;

                this.isLoading = true;

                await API.cancelbookingByHost({ id: bookingId });

                this.$swal({
                    title: this.$t('booking.booking_cancelled'),
                    text: this.$t('booking.booking_cancelled_success'),
                    icon: 'success',
                    type: 'success',
                    confirmButtonText: this.$t('common.ok')
                });

                this.loadData();
            } catch (err) {
                console.error("API call failed:", err);
                this.handleDataError(err);
            } finally {
                this.isLoading = false;
            }
        },
    },
    mounted() {
        this.loadData();
    }
};
</script>

<style>
.modal-header .close {
    padding: 1rem 1rem;
}

#invoice-modal .modal-body {
    padding: 0px;
}

#invoice-modal .modal-header {
    padding: 13px 32px 13px 20px;
    align-items: center;
}

#invoice-modal .modal-header .modal-title {
    font-size: 20px;
}

#invoice-modal .modal-header button.close {
    font-size: 20px;
}

#invoice-modal .modal-body::-webkit-scrollbar {
    width: 6px;
}

/* Track */
#invoice-modal .modal-body::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
}

/* Handle */
#invoice-modal .modal-body::-webkit-scrollbar-thumb {
    background: #70D3FF;
    border-radius: 10px;
}

/* Handle on hover */
#invoice-modal .modal-body::-webkit-scrollbar-thumb:hover {
    background: #555;
}

.invoice-table .top-content .header-logo img {
    width: auto;
    height: auto;
    max-width: 300px;
}

.invoice-table .top-content {
    padding: 20px 20px 0;
}

.invoice-table .top-content .invoice-btn {
    background-color: #70D3FF;
    border: 1px solid #70D3FF;
    border-radius: 6px !important;
    outline: none;
    box-shadow: none;
    padding: 10px 25px !important;
}

.invoice-table .top-content .invoice-btn:hover {
    background-color: #55cbff;
}

.invoice-table .top-content .invoice-btn span {
    font-size: 20px;
    font-weight: 700;
    line-height: 30px;
    text-transform: uppercase;
    color: #fff;
}

.invoice-table .body-content {
    padding: 20px;
}

.body-content .body-head {
    margin-bottom: 30px;
    padding-bottom: 10px;
    border-bottom: 1px solid #B6B6B6;
}

.body-content .body-head h3.title {
    font-size: 18px;
    line-height: 1.2;
    font-weight: 500;
    color: #000;
    margin-bottom: 20px;
}

.body-content h3.title {
    font-size: 18px;
    line-height: 1.2;
    font-weight: 500;
    color: #000;
    margin-bottom: 20px;
}

.body-content .body-head .row .col-lg-4:first-child {
    text-align: left;
}

.body-content .body-head .row .col-lg-4:nth-child(2) {
    text-align: center;
}

.body-content .body-head .row .col-lg-4:last-child {
    text-align: right;
}

.body-content .body-head .row .form-group {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.body-content .body-head .row .form-group label {
    margin-bottom: 0;
    font-size: 16px;
    font-weight: 400;
    line-height: normal;
    white-space: nowrap;
    color: #70D3FF;
    margin-right: 5px;
}

.invoice-table td,
.invoice-table th {
    padding: 12px;
}

.body-content .body-head .row .form-group span {
    margin-bottom: 0;
    font-size: 16px;
    font-weight: 400;
    line-height: normal;
    color: #000;
}

.body-content .responsive-table {
    margin-bottom: 30px;
}

.body-content .responsive-table table thead {
    background-color: #70D3FF;
    color: #fff;
}

.body-content .responsive-table.financial-table table thead tr th:nth-child(1) {
    width: 30%;
}

.body-content .responsive-table.financial-table table thead tr th:nth-child(2) {
    width: 60%;
}

.body-content .responsive-table.financial-table table thead tr th:nth-child(3) {
    width: 10%;
    text-align: center;
    min-width: 160px;
}

.body-content .responsive-table.financial-table table tbody tr td:nth-child(3) {
    text-align: center;
    color: #70D3FF;
    font-weight: 600;
}

.body-content .responsive-table table thead tr th:nth-child(1) {
    width: 30%;
}

.body-content .responsive-table table thead tr th:nth-child(2) {
    width: 70%;
}

.body-content .responsive-table table thead tr th {
    font-size: 16px;
    font-weight: bold;
    line-height: normal;
    color: #fff;
    padding: 12px;
}

.body-content .responsive-table table tbody tr td {
    font-size: 16px;
    font-weight: 400;
    line-height: normal;
    color: #717171;
}

.body-content .price-list h3.amount {
    text-align: right;
    font-size: 16px;
    line-height: 1.2;
    font-weight: 500;
    color: #000;
    margin-bottom: 0px;
}

.body-content .price-list h3.amount span {
    text-align: right;
    font-size: 16px;
    line-height: 1.2;
    font-weight: 500;
    color: #70D3FF;
    margin-bottom: 0px;
}

.body-content p.description {
    font-size: 16px;
    font-weight: bold;
    line-height: normal;
    color: #717171;
    margin-bottom: 0px;
}

.invoice-table .footer-content {
    padding: 30px;
    background-color: #F2FAFD;
    text-align: center;
}

.invoice-table .footer-content p {
    font-size: 16px;
    font-weight: 400;
    line-height: normal;
    color: #717171;
    margin-bottom: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
}

.invoice-table.footer-content p span {
    white-space: nowrap;
    padding: 0 5px;
}

.invoice-table .footer-content p span:not(:last-child) {
    border-right: 2px solid #717171;
}

.tab-content {
    display: none;
}

.nav-tabs .nav-item .nav-link {
    font-weight: bold;
}

.nav-tabs .nav-item .nav-link.active {
    border-radius: 0;
    background: #70D3FF;
    border: 1px solid #70D3FF;
    color: #fff;
}

.nav-tabs .nav-item .nav-link {
    border: 1px solid #dcdfe6;
}

.card-header .nav-tabs {
    display: flex;
    margin-bottom: 0;
}

.mx-datepicker {
    width: 100%;
}

.mx-datepicker input:placeholder-shown {
    border: 1px solid #c9ccd7
}

.body-content .responsive-table table tbody tr td:first-child {
    width: 290px;
    max-width: 290px;
    white-space: break-spaces;
}

@media (max-width: 1200px) {
    #invoice-modal .modal-dialog.modal-lg {
        max-width: 90%;
    }

    .invoice-table .top-content {
        flex-wrap: wrap;
        gap: 20px;
    }
}

@media (max-width: 1023px) {
    #invoice-modal .modal-dialog.modal-lg {
        max-width: 95%;
    }

    .invoice-table .top-content {
        flex-wrap: wrap;
    }
}

@media (max-width: 992px) {
    .body-content .body-head .row .col-lg-4:last-child {
        text-align: left;
    }

    .invoice-table .top-content .header-logo img {
        max-width: 200px;
    }

    .body-content .responsive-table table tbody tr td,
    .body-content .responsive-table table thead tr th,
    .body-content .body-head .row .form-group span,
    .body-content .body-head .row .form-group label,
    .body-content .price-list h3.amount,
    .body-content .price-list h3.amount span,
    .invoice-table .footer-content p {
        font-size: 14px;
    }
}

@media (max-width: 767.5px) {
    .body-content .body-head .row .col-lg-4:nth-child(2) {
        text-align: left;
    }

    .invoice-table .body-content {
        padding: 20px;
    }

    .invoice-table .footer-content {
        padding: 20px;
    }


    .body-content .body-head .row .form-group {
        flex-wrap: nowrap;
    }

    .body-content .body-head .row .form-group label {
        min-width: 150px;
    }
}

@media (max-width: 550px) {

    .invoice-table .top-content .invoice-btn {
        padding: 6px 20px !important;
    }

    .body-content .body-head .row .form-group label {
        min-width: 100px;
    }

    .invoice-table .footer-content p span:not(:last-child) {
        border-right: 1px solid #717171;
    }

    .card-header .nav-pills .nav-item .nav-link,
    .card-header .nav-tabs .nav-item .nav-link {
        padding: 9px;
    }
}

@media (max-width: 400px) {

    .body-content .body-head .row .form-group {
        flex-direction: column;
        align-items: flex-start;
    }

    .card-header .nav-tabs .nav-item {
        width: 100%;
    }
}

.modal-open .modal {
    margin-right: 0px !important;
}
</style>